const MERCHANT_CURRENCY_CODE_MAP = {
  GBP: "GBP",
  EUR: "EUR",
} as const

export const merchantCurrencyCodes = Object.values(
  MERCHANT_CURRENCY_CODE_MAP
)

export const merchantCurrencyDisplayLabels: Record<
  MerchantCurrencyCode,
  string
> = {
  GBP: "Pound (£)",
  EUR: "Euro (€)",
}

export type MerchantCurrencyCode =
  (typeof MERCHANT_CURRENCY_CODE_MAP)[keyof typeof MERCHANT_CURRENCY_CODE_MAP]

export const defaultMerchantCurrencyCode: MerchantCurrencyCode =
  "GBP"

export const merchantCurrencyCodeOptions =
  merchantCurrencyCodes.map((code) => ({
    value: code,
    label: merchantCurrencyDisplayLabels[code] ?? code,
  }))

export const isMerchantCurrencyCode = (
  value: any
): value is MerchantCurrencyCode =>
  merchantCurrencyCodes.includes(value)
